// extracted by mini-css-extract-plugin
module.exports = {"cellWrapper":"styles_cellWrapper__1wjGP","icon":"styles_icon__28yY_","activate":"styles_activate__2UIqr"};